class ProductGridVariantPrice extends HTMLElement {
  connectedCallback() {
    if (
      this.dataset.initialized ===
      'true'
    ) {
      return;
    }


    this.dataset.initialized =
      'true';

    this.sellingPrice =
      this.querySelector(
        '[data-selling-price]'
      );

    this.mrpPrice =
      this.querySelector(
        '[data-mrp-price]'
      );

    const productCard =
      this.closest('product-card');

    this.discountWrapper =
      productCard?.querySelector(
        '.shilpkala-media--hero [data-discount-wrapper]'
      );

    this.discountBadge =
      this.discountWrapper?.querySelector(
        '[data-custom-discount-badge]'
      );

    this.productUrl =
      this.dataset.productUrl;

    this.mediaMapElement =
      this.querySelector(
        '[data-shilpkala-card-media-map]'
      ) ||
      this.closest('product-card')
        ?.querySelector(
          '[data-shilpkala-card-media-map]'
        );


    this.mediaMap =
      null;


    if (this.mediaMapElement) {

      try {

        this.mediaMap =
          JSON.parse(
            this.mediaMapElement.textContent
          );

      } catch (error) {

        console.error(
          'Shilpkala card media map could not be parsed.',
          error
        );

      }

    }

    this.handleVariantDropdownChange =
      this.handleVariantDropdownChange.bind(this);

    this.addEventListener(
      'variant-dropdown:change',
      this.handleVariantDropdownChange
    );
  }


  disconnectedCallback() {
    this.removeEventListener(
      'variant-dropdown:change',
      this.handleVariantDropdownChange
    );
  }


  /* =====================================================
     VARIANT CHANGE
     ===================================================== */

  handleVariantDropdownChange(event) {
    const variantId =
      event.detail?.variantId;

    const option =
      event.detail?.option;


    if (
      !variantId ||
      !option
    ) {
      return;
    }


    /*
    * Everything below is product-card-specific.
    * The shared dropdown controller knows
    * nothing about these operations.
    */

    this.updateVariantLinks(
      variantId
    );


    this.updatePrice(
      option
    );


    this.updateDiscount(
      option
    );


    this.updateCardImage(
      variantId
    );


    this.dispatchEvent(
      new CustomEvent(
        'card:variant-change',
        {
          bubbles: true,

          detail: {
            variantId
          }
        }
      )
    );
  }


  /* =====================================================
     URLS
     ===================================================== */

  updateVariantLinks(variantId) {
    if (!this.productUrl) {
      return;
    }


    const variantUrl =
      `${this.productUrl}?variant=${variantId}`;


    const productCard =
      this.closest(
        'product-card'
      );


    if (!productCard) {
      return;
    }


    const productLinks =
      productCard.querySelectorAll(
        `a[href*="${this.productUrl}"]`
      );


    productLinks.forEach(link => {

      link.href =
        variantUrl;

    });


    const quickLookTrigger =
      productCard.querySelector(
        '[data-custom-quick-look-trigger]'
      );


    if (quickLookTrigger) {

      quickLookTrigger.dataset.productUrl =
        variantUrl;

    }
  }


  /* =====================================================
     PRICE
     ===================================================== */

  updatePrice(option) {
    const price =
      option.dataset.price;


    const comparePrice =
      option.dataset.comparePrice;


    const priceRaw =
      Number(
        option.dataset.priceRaw || 0
      );


    const comparePriceRaw =
      Number(
        option.dataset.comparePriceRaw || 0
      );


    if (
      this.sellingPrice &&
      price
    ) {

      this.sellingPrice.textContent =
        price;

    }


    if (!this.mrpPrice) {
      return;
    }


    if (
      comparePriceRaw >
      priceRaw
    ) {

      this.mrpPrice.textContent =
        comparePrice;


      this.mrpPrice.hidden =
        false;

    } else {

      this.mrpPrice.hidden =
        true;

    }
  }


  /* =====================================================
     DISCOUNT
     ===================================================== */

  updateDiscount(option) {
    if (!this.discountBadge) {
      return;
    }

    const discountPercent =
      Number(
        option.dataset.discountPercent || 0
      );

    if (discountPercent > 0) {
      this.discountBadge.textContent =
        `${discountPercent}% off`;

      this.discountBadge.hidden = false;
    } else {
      this.discountBadge.hidden = true;
    }
  }


  /* =====================================================
     PRODUCT CARD IMAGE
     ===================================================== */

  updateCardImage(variantId) {
    if (!this.mediaMap) {
      return;
    }


    const media =
      this.mediaMap.variants?.[
        String(variantId)
      ];


    if (!media?.url) {
      return;
    }


    const productCard =
      this.closest(
        'product-card'
      );


    if (!productCard) {
      return;
    }


    const hero =
      productCard.querySelector(
        '.shilpkala-media--hero'
      );


    const image =
      hero?.querySelector(
        'img'
      );


    if (!image) {
      return;
    }


    /*
     * Compare URL paths rather than raw
     * image.src strings where possible.
     */
    if (
      image.currentSrc === media.url ||
      image.src === media.url
    ) {
      return;
    }


    image.classList.add(
      'shilpkala-media__image--switching'
    );


    const preloadImage =
      new Image();


    preloadImage.decoding =
      'async';


    preloadImage.onload =
      () => {

        image.src =
          media.url;


        image.alt =
          media.alt || '';


        /*
         * Existing srcset could cause the browser
         * to continue rendering the old responsive
         * image after changing src.
         */
        image.removeAttribute(
          'srcset'
        );


        if (media.width) {

          image.width =
            media.width;

        }


        if (media.height) {

          image.height =
            media.height;

        }


        requestAnimationFrame(() => {

          image.classList.remove(
            'shilpkala-media__image--switching'
          );

        });

      };


    preloadImage.onerror =
      () => {

        image.classList.remove(
          'shilpkala-media__image--switching'
        );

      };


    preloadImage.src =
      media.url;
  }
}


if (
  !customElements.get(
    'product-grid-variant-price'
  )
) {

  customElements.define(
    'product-grid-variant-price',
    ProductGridVariantPrice
  );

}